import { useState, useEffect } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import getConfig from "next/config";
import GiftCardForm from "@components/GiftCardForm";
import Breadcrumbs from "@components/Breadcrumbs";
// import { Tabs, Tab } from "@components/ProductTabs"; //? Remove after codereview
import Link from "next/link";
import Accordion from "@components/Accordion";
import AccordionItem from "@components/Accordion/Item";
import AccordionItemHeader from "@components/Accordion/Item/Header";
import AccordionItemBody from "@components/Accordion/Item/Body";
import Heading from "@components/Heading";
import { useRouter } from "next/router";
import { getSlug } from "@lib/helpers";
// import GiftCardIcon from "@components/Icons/GiftCardIcon";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
    settings: { websiteStatics, websiteName },
  },
} = getConfig();

const GiftCard = ({ user }) => {
  const { asPath } = useRouter();
  const [openedSection, setOpenedSection] = useState("");

  useEffect(() => {
    const hash = asPath.split("#")[1];

    if (hash) {
      const hashSlug = getSlug(hash);
      const sectionElement = document.getElementById(hashSlug);

      if (sectionElement) {
        setOpenedSection(hashSlug);
      }
    }
  }, []);

  const onAccordionItemToggle = ({ item, expanded }) =>
    history.replaceState({}, "", `#${expanded ? item : ""}`);

  return (
    <>
      <Head>
        <title>
          Card Cadou {websiteTitle} 🎁 Daruieste un cadou special - Gift Card{" "}
          {websiteTitle}
        </title>
        <meta
          name="description"
          content={`Cumpara un Card Cadou ${websiteTitle} si ofera celor apropiati un cadou diferit! ⭐ Acum cu un Gift Card ${websiteTitle} ei pot sa achizitioneze exact ceea ce isi doresc. ✔️ ${websiteTitle}`}
        />
        <meta name="keywords" content="card, cadou, gift, dar" />
      </Head>

      <Breadcrumbs
        breadcrumbs={[
          {
            id: 1,
            level: 99,
            name: "Carduri cadou",
          },
        ]}
      />

      <div className="flex flex-col items-center justify-center w-full space-y-8 mt-10">
        {/* <div className="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0 items-center justify-between px-6 py-5 md:py-10 md:px-16 w-full bg-[#F7F9FF] rounded-tr-xl rounded-bl-xl">
          <h2
            className={`font-semibold italic max-w-full ${
              websiteTitle === "Altex"
                ? "md:max-w-xl text-red-brand text-2xl md:text-3xl lg:text-5xl leading-8 lg:leading-[62px]"
                : "md:max-w-2xl text-bleu-dark text-2xl md:text-3xl lg:text-[2.9rem] leading-8 lg:leading-[60px]"
            }`}
          >
            Daruieste-le celor dragi un card cadou de la {websiteTitle} :)
          </h2>

          <div className="flex items-center justify-center max-w-full md:max-w-md w-full">
            <GiftCardIcon website={websiteTitle} />
          </div>
        </div> */}

        {/* TODO update giftcard banner for brico, then drop this condition */}
        {websiteName !== "bricostore" && (
          <>
            <div className="block md:hidden w-full bg-[#F7F9FF] rounded-xl">
              <img
                src={`${websiteStatics}/images/giftcard-banner-mobile.png`}
                alt="Daruieste celor dragi un card cadou virtual!"
              />
            </div>

            <div className="hidden md:block w-full bg-[#F7F9FF] rounded-xl">
              <img
                src={`${websiteStatics}/images/giftcard-banner.png`}
                alt="Daruieste celor dragi un card cadou virtual!"
              />
            </div>
          </>
        )}

        <GiftCardForm user={user} />

        <h1 className="font-normal text-2xl leading-10 md:text-3xl md:leading-42 w-full">
          Card Cadou {websiteTitle}
        </h1>

        <p className="text-base">
          Lasa-te inspirat de cea mai simpla varianta de a oferi un cadou, cu
          noile carduri cadou virtuale de la {websiteTitle}, numai bune de
          daruit celor dragi. Acest card cadou iti permite sa oferi cadou o suma
          cuprinsa intre 200 si 5000 de lei ce poate fi folosita la
          achizitionarea oricarui* produs din{" "}
          <Link href="/">
            <a className="font-semibold text-red-brand">{websiteTitle}</a>
          </Link>
        </p>
        <p className="text-base">
          Cardul cadou virtual poate fi folosit la achizitionarea oricarui
          produs* din site-ul{" "}
          <Link href="/">
            <a className="font-semibold text-red-brand">{websiteTitle}</a>
          </Link>
          , mai putin Asigurari, Cartele Prepaid, cat si pentru achizitionarea
          produselor vandute si livrate de catre Partenerii Altex Marketplace,
          produse evidentiate in site ca fiind "Vandut si livrat de: [plus
          denumirea Partenerului Altex Marketplace].
        </p>

        <Link
          // TODO: add href for bricostore giftcard??
          href={
            websiteName === "altex"
              ? "https://lcdn.altex.ro/media/custom/upload/regulament-card-cadou-virtual-altex.pdf"
              : "https://lcdn.mediagalaxy.ro/media/custom/upload/regulament-card-cadou-virtual-mediagalaxy.pdf"
          }
        >
          <a className="font-semibold text-red-brand w-full">Regulament</a>
        </Link>

        <div className="w-full">
          <div className="space-y-2 py-2 divide-y divide-black/30 border-y">
            <Accordion
              expandedItems={openedSection}
              onToggle={onAccordionItemToggle}
            >
              <AccordionItem id="valabilitatea-cardului-cadou">
                <AccordionItemHeader>
                  <Heading title="Valabilitatea cardului cadou" />
                </AccordionItemHeader>

                <AccordionItemBody>
                  <div className="mb-5">
                    Cardul cadou are o valabilitate de 12 luni de la data
                    emiterii.
                  </div>
                </AccordionItemBody>
              </AccordionItem>

              <AccordionItem id="suma-minima-si-maxima-a-cardului">
                <AccordionItemHeader>
                  <Heading title="Suma minima si maxima a cardului" />
                </AccordionItemHeader>

                <AccordionItemBody>
                  <div className="mb-5">
                    Cardurile cadou pot avea valoarea cuprinsa intre 200 si 5000
                    de lei.
                  </div>
                </AccordionItemBody>
              </AccordionItem>

              <AccordionItem id="regulament-privind-utilizarea-cardului">
                <AccordionItemHeader>
                  <Heading title="Regulament privind utilizarea cardului" />
                </AccordionItemHeader>

                <AccordionItemBody>
                  <ul className="mb-5 list-[disc] list-inside">
                    <li>
                      Cardul Cadou poate fi utilizat imediat dupa emitere;
                    </li>
                    <li>
                      Cardul Cadou Virtual se poate achizitiona DOAR singur in
                      cos, fara alte produse/servicii in aceeasi comanda;
                    </li>
                    <li>
                      Un client poate achizitiona mai multe Carduri Cadou
                      Virtuale doar prin comenzi separate/individuale, pentru
                      fiecare card in parte, iar fiecare comanda poate fi
                      plasata doar fara alte produse/servicii in cosul de
                      cumparaturi;
                    </li>
                    <li>
                      Cardul Cadou Virtual poate fi utilizat in limita sumei
                      incarcate pe acesta;
                    </li>
                    <li>Cardul Cadou Virtual nu se poate reincarca;</li>
                    <li>
                      Cardul Cadou Virtual nu se cumuleaza cu un alt Card Cadou
                      Virtual pentru aceeasi comanda. Poate fi cumulat cu un
                      cupon de cumparaturi sau mai multe cupoane care pot fi
                      cumulate, in conditiile stabilite pentru fiecare campanie
                      aplicabila, la aceeasi comanda.
                    </li>
                  </ul>
                </AccordionItemBody>
              </AccordionItem>

              <AccordionItem id="intrebari-frecvente">
                <AccordionItemHeader>
                  <Heading title="Intrebari frecvente" />
                </AccordionItemHeader>

                <AccordionItemBody>
                  <ul className="mb-5 list-[disc] list-inside">
                    <li>
                      <span className="font-semibold">
                        Ce valabilitate are cardul cadou?
                      </span>

                      <div>
                        Cardul cadou are o valabilitate de 12 luni de la data
                        emiterii.
                      </div>
                    </li>

                    <li>
                      <span className="font-semibold">
                        Ce valoare are cardul cadou?
                      </span>

                      <div>
                        Cardurile cadou pot avea valoarea cuprinsa intre 200 si
                        5000 de lei.
                      </div>
                    </li>

                    <li>
                      <span className="font-semibold">
                        Ce produse pot cumpara cu cardul cadou?
                      </span>

                      <div>
                        Cardul cadou poate fi folosit la achizitionarea oricarui
                        produs din oferta Altex, MediaGalaxy sau Brico mai putin
                        Asigurari si Cartele Prepaid.
                      </div>
                    </li>
                  </ul>
                </AccordionItemBody>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

GiftCard.pageLayout = "default";

export default connect((state) => ({
  user: state.user,
}))(GiftCard);
